module.exports = __webpack_public_path__ + "img/i_mytown_s_grey.a5459a27.svg";